var mapModals = {
  deleteDrawing: function(translations) {
    var modal;

    modal =   '<div class="modal" id="deleteDrawingModal" tabindex="-1">';
    modal +=    '<div class="modal-dialog modal-sm c-modal">';
    modal +=      '<div class="c-modal__content">';
    modal +=          translations.discard_warning_message;
    modal +=      '</div>';
    modal +=      '<div class="c-modal__footer">';
    modal +=        '<button type="button" id="discardDrawingsBtn" class="btn btn-tertiary" data-dismiss="modal">';
    modal +=          translations.discard;
    modal +=        '</button>';
    modal +=        '<button type="button" class="btn btn-primary" data-dismiss="modal">';
    modal +=          translations.keep;
    modal +=        '</button>';
    modal +=      '</div>';
    modal +=    '</div>';
    modal +=  '</div>';

    return modal;
  }

}


export default mapModals;
